<template>
  <div v-show="loading" style="width: 100%; height: 100%">
    <a-spin
      style="
        width: 100%;
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
      "
    >
    </a-spin>
  </div>
</template>

<script>
export default {
  props: ["loading"],
};
</script>

<style lang="sass" scoped></style>
